import {
  BookOpen, Stethoscope, HandHeart, Baby, TreePine, Droplets, HeartHandshake,
  Scissors, Megaphone, ShieldCheck, Users, Building2, Landmark, CalendarHeart, Package,
} from "lucide-react";

const map = {
  BookOpen, Stethoscope, HandHeart, Baby, TreePine, Droplets, HeartHandshake,
  Scissors, Megaphone, ShieldCheck, Users, Building2, Landmark, CalendarHeart, Package,
};

export default function Icon({ name, ...props }) {
  const Cmp = map[name] || HeartHandshake;
  return <Cmp {...props} />;
}
